














import { apiPageConfigDecorateGetPage } from '@/api'
import { computed } from '@vue/composition-api'
import { defineClassComponent, useApiPlus, useQuery } from '@/hooks'
import { devOrProd, Track } from '@/utils'
import { loadCss } from 'vtils'
import { redirectTo } from '@/router'

export default defineClassComponent<{
  pageType: 'page' | 'store' | 'preview'
  pageId: string
}>(
  {
    props: ['pageType', 'pageId'],
  },
  ({ props }) =>
    class {
      constructor() {
        Track.useMark(
          () => ({
            // @ts-ignore
            page: this.pageConfig.value.style.title,
            id: this.query.id,
          }),
          () => !this.loading.value,
        )
      }

      loading = computed(() => this.apiData.loading)

      query = useQuery<{
        /** 类型 */
        type: 'page' | 'store' | 'preview'
        /** ID */
        id: string
      }>({
        type: {
          default: props.pageType || 'page',
        },
        id: {
          default: props.pageId || '8aaa8c3085a3e7df0185a3f2d6e60002',
        },
      })

      apiData = useApiPlus(
        {
          pageConfig: () =>
            apiPageConfigDecorateGetPage(
              {
                type: this.query.type,
                id: this.query.id,
              },
              {
                useCdnData: location.href.includes('isCdn=true')
                  ? `https://dcb-resource.${devOrProd(
                      'duotest',
                      'gogpay',
                    )}.cn/mall-platform/dcb-mall/decorate/${
                      this.query.id
                    }.json`
                  : undefined,
              },
            ).then(res => {
              if (this.query.type === 'store' && !res.hasDecorate) {
                redirectTo('MartIndex', {
                  id: this.query.id,
                })
                throw ''
              }
              // @ts-ignore
              document.title = res.style.title
              // @ts-ignore
              if (res.style.css) {
                // @ts-ignore
                loadCss(res.style.css)
              }

              Track.pushEvent({
                type: 'load',
                name: '浏览自定义页面',
                id: 'LiuLanZiDingYiYe',
                extra: {
                  page_id: this.query.id,
                  // @ts-ignore
                  page_name: res.style.title,
                },
              })

              return {
                ...res,
                type: 'PAGE',
              }
            }),
        },
        {
          refreshOnActivated: true,
        },
      )

      pageConfig = computed(() => this.apiData.data.pageConfig)
    },
)
